
import React from 'react'

import './KanbanTaskResponsibles.scss'
import UserAvatar from '../UserAvatar/UserAvatar';

interface Props {
  responsibles: any[];
}

const KanbanTaskResponsibles = ({ responsibles }: Props) => {

  return (
    <div className="kanban-task-responsibles"
      style={{
        position: 'relative'
      }}
    >
      {responsibles.map((resp: any, i: number) => (
        <div key={resp._id}
          style={{
            marginLeft: '-.5rem',
            zIndex: responsibles.length - i
          }}
        >
          <UserAvatar
            user={resp}
            size={'xs'}
          />
        </div>
      ))}
    </div>
  )
}

export default KanbanTaskResponsibles
